export default class State {
  constructor() {
    this.organization = {};
    this.organizationId = null;
    this.errors = [];
  }
}
